export const servicesData = [
  {
    id: 'it-consulting',
    title: 'IT Consulting',
    price: 299,
    category: 'IT Services',
    image: 'https://public.readdy.ai/ai/img_res/c86ba7bedec522ad26848ff7119d9d97.jpg',
    description: 'Strategic IT guidance to align technology with your business goals and drive digital transformation.',
    features: [
      'Technology Assessment & Roadmap: Comprehensive evaluation of your current IT infrastructure and strategic planning for future growth.',
      'Digital Transformation Strategy: Guide your organization through modernization initiatives with proven methodologies.',
      'IT Budget Planning & Optimization: Maximize ROI on technology investments with expert financial planning.',
      'Vendor Selection & Management: Navigate complex technology decisions with unbiased recommendations.',
      'Risk Assessment & Mitigation: Identify vulnerabilities and implement proactive solutions.',
      'Performance Optimization: Fine-tune systems for maximum efficiency and productivity.'
    ]
  },
  {
    id: 'cloud-migration',
    title: 'Cloud Migration',
    price: 599,
    category: 'IT Services',
    image: 'https://readdy.ai/api/search-image?query=Cloud%20computing%20infrastructure%20visualization%20with%20servers%20data%20flowing%20upward%20into%20digital%20cloud%20network%20showing%20migration%20process%20with%20abstract%20geometric%20patterns%20and%20connectivity%20nodes%20on%20clean%20gradient%20background%20representing%20seamless%20technology%20transition&width=600&height=600&seq=cloudmig001&orientation=squarish',
    description: 'Seamless transition to cloud infrastructure with minimal downtime and maximum efficiency.',
    features: [
      'Cloud Readiness Assessment: Evaluate applications and workloads for optimal cloud deployment strategies.',
      'Multi-Cloud Strategy: Design and implement solutions across AWS, Azure, and Google Cloud platforms.',
      'Data Migration & Synchronization: Secure transfer of critical data with zero loss and minimal disruption.',
      'Application Modernization: Refactor legacy systems to leverage cloud-native capabilities.',
      'Cost Optimization: Implement resource management strategies to reduce cloud spending by up to 40%.',
      'Post-Migration Support: Ongoing monitoring and optimization to ensure peak performance.'
    ]
  },
  {
    id: 'business-support',
    title: 'Business Support Services',
    price: 349,
    category: 'Business Services',
    image: 'https://readdy.ai/api/search-image?query=Professional%20business%20support%20team%20collaborating%20with%20digital%20workflow%20automation%20tools%20project%20management%20dashboards%20and%20strategic%20planning%20documents%20in%20modern%20office%20setting%20with%20clean%20organized%20workspace%20emphasizing%20efficiency%20and%20professional%20assistance&width=600&height=600&seq=bizsupport001&orientation=squarish',
    description: 'Comprehensive business support solutions to streamline operations and accelerate growth.',
    features: [
      'Administrative Support: Professional handling of scheduling, documentation, and daily operational tasks.',
      'Process Optimization: Analyze and improve workflows to increase efficiency and reduce operational costs.',
      'Project Management: Expert coordination of initiatives with proven methodologies and tools.',
      'Business Analysis: Data-driven insights to identify opportunities and solve complex challenges.',
      'Virtual Assistant Services: Dedicated remote support for executive and administrative functions.',
      'Workflow Automation: Implement smart solutions to eliminate repetitive tasks and boost productivity.'
    ]
  },
  {
    id: 'advertisement-marketing',
    title: 'Advertisement & Marketing Services',
    price: 449,
    category: 'Marketing Services',
    image: 'https://readdy.ai/api/search-image?query=Creative%20marketing%20campaign%20visualization%20with%20advertising%20graphics%20brand%20strategy%20elements%20digital%20marketing%20analytics%20and%20promotional%20content%20design%20on%20vibrant%20modern%20background%20emphasizing%20creativity%20innovation%20and%20brand%20growth&width=600&height=600&seq=admarket001&orientation=squarish',
    description: 'Strategic advertising and marketing campaigns that drive brand awareness and customer engagement.',
    features: [
      'Brand Strategy Development: Create compelling brand identities that resonate with your target audience.',
      'Digital Advertising Campaigns: Multi-channel paid advertising across Google, Facebook, LinkedIn, and more.',
      'Content Marketing: Engaging content creation including blogs, videos, and infographics that convert.',
      'SEO & SEM Optimization: Improve search rankings and drive qualified traffic to your digital properties.',
      'Marketing Analytics: Track campaign performance with detailed reporting and actionable insights.',
      'Creative Design Services: Professional graphics, videos, and marketing materials that stand out.'
    ]
  },
  {
    id: 'smm-management',
    title: 'SMM Management Services',
    price: 399,
    category: 'Marketing Services',
    image: 'https://readdy.ai/api/search-image?query=Social%20media%20management%20dashboard%20showing%20multiple%20platform%20interfaces%20with%20engagement%20metrics%20content%20calendar%20scheduling%20tools%20and%20community%20interaction%20analytics%20on%20clean%20modern%20background%20emphasizing%20digital%20presence%20and%20audience%20growth&width=600&height=600&seq=smmmanage001&orientation=squarish',
    description: 'Professional social media management to build your online presence and engage your audience.',
    features: [
      'Social Media Strategy: Customized plans aligned with your business goals and target demographics.',
      'Content Creation & Scheduling: Daily posts, stories, and reels designed to maximize engagement.',
      'Community Management: Active monitoring and response to comments, messages, and reviews.',
      'Influencer Partnerships: Connect with relevant influencers to expand your reach and credibility.',
      'Social Media Advertising: Targeted ad campaigns on Instagram, Facebook, TikTok, and Twitter.',
      'Performance Analytics: Monthly reports with insights on growth, engagement, and ROI metrics.'
    ]
  }
];